import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { API_URL } from '../config.js';
import { FaRegCircleCheck } from 'react-icons/fa6';
import { FaTimesCircle } from 'react-icons/fa';
import SpinLoader from '../components/SpinLoader.js';

const BikePaymentSuccess = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const [paymentStatus, setPaymentStatus] = useState('');
    const query = new URLSearchParams(location.search);
    const orderId = query.get('order_id');
    // console.log('✌️orderId --->', orderId);

    const fetchPaymentStatus = async () => {
        try {
            // const response = await fetch(`https://api.uklogistic.com/order-status/${orderId}`);
            const response = await fetch(`${API_URL}/orderstatus/${orderId}`);
            // console.log('✌️response --->', response);
            const data = await response.json();
            // console.log('✌️data --->', data);
            let getOrderResponse = data;
            // console.log('✌️getOrderResponse --->', getOrderResponse);
            let orderStatus;

            if (getOrderResponse.filter(transaction => transaction.payment_status === "SUCCESS").length > 0) {
                orderStatus = "Success"
                setTimeout(() => {
                    navigate('/bikeallorder');
                }, 500);

                // console.log("calll=====================11111111111111")
            } else if (getOrderResponse.filter(transaction => transaction.payment_status === "FAILED").length > 0) {
                orderStatus = "Failure"

                // console.log("llllllllllllll")
            } else {
                orderStatus = "Pending"
                // console.log('✌️Failure --->');

            }

            setPaymentStatus(orderStatus);
        } catch (error) {
            // console.log('✌️error --->', error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (orderId) {
            // console.log("calll=====================+")
            fetchPaymentStatus();
        }
    }, [orderId]);

    return (
        <div>
            {loading ? (

                <SpinLoader classNamecolor='true' />

            ) : (<>
                {paymentStatus === 'Success' && <div className="min-h-screen flex flex-col items-center justify-center bg-green-600">
                    <div className="bg-white shadow-lg md:rounded-lg p-6 md:p-10 max-w-md w-full">
                        <div className="flex flex-col items-center text-center">
                            <div className="flex-shrink-0 relative">
                                {/* Outer circle animation (small size) */}
                                <div className="absolute inset-0 w-32 sm:w-24 h-32 sm:h-24 bg-green-100 rounded-full animate-ping"></div>
                                {/* Icon container */}
                                <div className="relative w-32 sm:w-24 h-32 sm:h-24 bg-green-200 rounded-full flex items-center justify-center transform transition-all duration-300 hover:scale-105 cursor-pointer">
                                    {/* Replace FcBusinessman with any desired icon */}
                                    <FaRegCircleCheck className="text-6xl text-green-600" />
                                </div>
                            </div>
                            <h2 className="t font-semibold text-gray-800 mt-4">Payment Successful!</h2>
                            <p className="text-gray-600 font-semibold mt-2">
                                Your Shipment has been placed successfully.
                            </p>
                        </div>
                        <Link to="/bikeallorder">   <button
                            className="mt-6 w-full bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-300"
                        // onClick={() => alert('Redirecting to Orders Page')}
                        >
                            View Orders
                        </button></Link>
                    </div>
                </div>}
                {paymentStatus === 'Failure' &&
                    <div className="min-h-screen flex flex-col items-center justify-center bg-red-400">
                        <div className="bg-white shadow-lg md:rounded-lg p-6 md:p-10 max-w-md w-full">
                            <div className="flex flex-col items-center text-center">
                                <div className="flex-shrink-0 relative">
                                    {/* Outer circle animation (small size) */}
                                    <div className="absolute inset-0 w-32 sm:w-24 h-32 sm:h-24 bg-red-100 rounded-full animate-ping"></div>
                                    {/* Icon container */}
                                    <div className="relative w-32 sm:w-24 h-32 sm:h-24 bg-red-200 rounded-full flex items-center justify-center transform transition-all duration-300 hover:scale-105 cursor-pointer">
                                        {/* Replace FaRegCircleCheck with an error icon */}
                                        <FaTimesCircle className="text-6xl text-red-600" />
                                    </div>
                                </div>
                                <h2 className="font-semibold text-gray-800 mt-4">Payment Unsuccessful</h2>
                                <p className="text-gray-600 font-semibold mt-2">
                                    Unfortunately, your payment could not be processed. Please try again.
                                </p>
                            </div>
                            <Link to="/bikeallorder">  <button
                                className="mt-6 w-full bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-300"
                            //   onClick={() => alert('Retrying Payment')}
                            >
                                View Orders
                            </button></Link>
                        </div>
                    </div>
                }
            </>
            )}
        </div>
    )
}

export default BikePaymentSuccess
